import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import Routes from "./Routes";
import "./index.css";

const root = createRoot(document.getElementById("root"));
root.render(
  <StrictMode>
    <Routes />
  </StrictMode>
);
